import { Link } from '@tanstack/react-router'
import { FaHome, FaBook, FaTools, FaLifeRing } from 'react-icons/fa'

const tabs = [
  { to: '/', label: 'Home', icon: FaHome, exact: true },
  { to: '/learn', label: 'Learn', icon: FaBook, exact: false },
  { to: '/tools', label: 'Tools', icon: FaTools, exact: false },
  { to: '/help', label: 'Support', icon: FaLifeRing, exact: false },
] as const

/**
 * Persistent bottom tab bar on phones. The hamburger menu is the most-missed
 * pattern for older users; always-visible labelled tabs keep Tools and
 * Support discoverable. Hidden from sm: up (the top nav carries the links).
 */
export default function MobileTabBar() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur-sm pb-[env(safe-area-inset-bottom)] sm:hidden"
    >
      <ul className="grid grid-cols-4">
        {tabs.map(({ to, label, icon: Icon, exact }) => (
          <li key={to}>
            <Link
              to={to}
              search={{ invitationcode: undefined, __clerk_ticket: undefined }}
              activeOptions={{ exact }}
              className="flex min-h-14 flex-col items-center justify-center gap-1 py-1.5 text-slate-500"
              activeProps={{
                className:
                  'flex min-h-14 flex-col items-center justify-center gap-1 py-1.5 text-violet-700',
                'aria-current': 'page',
              }}
            >
              <Icon size={20} aria-hidden />
              <span className="text-[12px] font-medium leading-none">{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
